import { observer } from "mobx-react";
import * as React from "react";
import { ADMIN_NAV_ITEMS, CALCULO_ITEMS_SUB, CALCULO_ITENS, INavItem, NAV_ITEMS4, NAV_LEGISLACAO_ARQUIVOS_PA, NAV_LEGISLACAO_RS, NAV_LEGISLACAO_TABELAS_PA, PRODUTOS_ITEMS_SUB, VARS_ITEMS_SUB, XMLS_ITEMS, XMLS_ITEMS_SUB } from "./NavItens";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Collapse } from "@mui/material";
import { observable } from "mobx";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { AppIcon } from "../utils/AppIcon";

require("../../assets/css/components/NavMenu.css");

export interface Props {
  onClick: (value: string) => void;
  isOpen: boolean
}

interface State {
  declaracoes: boolean
  xmls: boolean
  solicitacao: boolean
  calculos: boolean
  legislacao: boolean
  legislacao_rs: boolean
  legislacao_pa: boolean
  arquivos: boolean
  tabelas_rs: boolean
  tabelas_pa: boolean
  relatorios: boolean
  admin: boolean
  utilitarios: boolean
  calcs: boolean
  vars: boolean
  produtos: boolean
}

@observer
export default class NavMenuAdminMobile extends React.Component<Props, State> {

  obs = observable({
  })

  constructor(props) {
    super(props);

    this.state = {
      declaracoes: false,
      xmls: false,
      solicitacao: false,
      calculos: false,
      legislacao: false,
      legislacao_rs: false,
      legislacao_pa: false,
      arquivos: false,
      tabelas_rs: false,
      tabelas_pa: false,
      relatorios: false,
      admin: false,
      utilitarios: false,
      calcs: false,
      vars: false,
      produtos: false
    };

  }

  componentDidUpdate(prevProps) {

    if (prevProps.isOpen && !this.props.isOpen) {

      this.handleCloseMenus()

    }

  }

  handleCloseMenus() {

    this.setState({
      declaracoes: false,
      xmls: false,
      solicitacao: false,
      calculos: false,
      legislacao: false,
      legislacao_rs: false,
      legislacao_pa: false,
      arquivos: false,
      tabelas_rs: false,
      tabelas_pa: false,
      relatorios: false,
      admin: false,
      utilitarios: false,
      calcs: false,
      vars: false
    })

  }

  renderItem = (item: INavItem[]) => {

    return (<>

      {item.map((setting) => (
        <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
          <ListItemText className='btn-list-header' primary={setting.text} />
        </ListItemButton>
      ))}

    </>);
  };

  renderDashboard() {

    return (

      <ListItemButton onClick={() => this.props.onClick("/dashboard")}>
        <ListItemText className='btn-list-header' primary="Dashboard" />
      </ListItemButton>

    )

  }

  renderEmpresas() {

    return (
      <ListItemButton onClick={() => { EmpresaStore.obs.certificado = ""; EmpresaStore.obs.status = ""; this.props.onClick("/empresas") }}>
        <ListItemText className='btn-list-header' primary="Empresas" />
      </ListItemButton>
    )
  }

  renderDeclaracoes() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ declaracoes: !this.state.declaracoes })
      }}>
        <ListItemText className='btn-list-header' primary="Declarações" />
        {this.state.declaracoes ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.declaracoes} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {NAV_ITEMS4.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

        </List>
      </Collapse>

    </>)

  }

  renderXmlsRS() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ xmls: !this.state.xmls })
      }}>
        <ListItemText className='btn-list-header' primary="XMLs" />
        {this.state.xmls ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.xmls} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {XMLS_ITEMS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

        </List>
      </Collapse>

    </>)

  }

  renderXmlsPA() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ xmls: !this.state.xmls })
      }}>
        <ListItemText className='btn-list-header' primary="XMLs" />
        {this.state.xmls ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.xmls} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {XMLS_ITEMS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

          <ListItemButton sx={{ pl: 4 }} onClick={() => this.setState({ solicitacao: !this.state.solicitacao })}>
            <ListItemText className='btn-list-header' primary="Solicitações de Arquivos" />
            {this.state.solicitacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.solicitacao} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>

              {XMLS_ITEMS_SUB.map((setting) => (
                <ListItemButton sx={{ pl: 8 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}

            </List>
          </Collapse>
        </List>
      </Collapse>

    </>)

  }

  renderCalculos() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ calculos: !this.state.calculos })
      }}>
        <ListItemText className='btn-list-header' primary="Cálculos" />
        {this.state.calculos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.calculos} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {CALCULO_ITENS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

    </>)

  }

  renderLegislacaoPA() {

    return (<>

      <ListItemButton sx={{ pl: 4 }} onClick={() => {
        this.setState({ legislacao_pa: !this.state.legislacao_pa })
      }}>
        <ListItemText className='btn-list-header' primary="Pará" />
        {this.state.legislacao_pa ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao_pa} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ arquivos: !this.state.arquivos })
          }}>
            <ListItemText className='btn-list-header' primary="Arquivos" />
            {this.state.arquivos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.arquivos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_ARQUIVOS_PA.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ tabelas_pa: !this.state.tabelas_pa })
          }}>
            <ListItemText className='btn-list-header' primary="Tabelas" />
            {this.state.tabelas_pa ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.tabelas_pa} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_TABELAS_PA.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>
      </Collapse>

    </>)

  }

  renderLegislacaoRS() {

    return (<>

      <ListItemButton sx={{ pl: 4 }} onClick={() => {
        this.setState({ legislacao_rs: !this.state.legislacao_rs })
      }}>
        <ListItemText className='btn-list-header' primary="Rio Grande do Sul" />
        {this.state.legislacao_rs ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao_rs} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ tabelas_rs: !this.state.tabelas_rs })
          }}>
            <ListItemText className='btn-list-header' primary="Tabelas" />
            {this.state.tabelas_rs ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.tabelas_rs} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_RS.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>
      </Collapse>

    </>)

  }

  renderLegislacao() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ legislacao: !this.state.legislacao })
      }}>
        <ListItemText className='btn-list-header' primary="Legislação" />
        {this.state.legislacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {this.renderLegislacaoPA()}
          {this.renderLegislacaoRS()}
        </List>
      </Collapse>

    </>)

  }

  renderAdmin() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ admin: !this.state.admin })
      }}>
        <ListItemText className='btn-list-header' primary="Admin" />
        {this.state.admin ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.admin} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {ADMIN_NAV_ITEMS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

          <ListItemButton sx={{ pl: 4 }} onClick={() => {
            this.setState({ calcs: !this.state.calcs })
          }}>
            <ListItemText className='btn-list-header' primary="Formas de cálculos" />
            {this.state.calcs ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.calcs} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {CALCULO_ITEMS_SUB.map((setting) => (
                <ListItemButton sx={{ pl: 8 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton sx={{ pl: 4 }} onClick={() => {
            this.setState({ produtos: !this.state.produtos })
          }}>
            <ListItemText className='btn-list-header' primary="Produtos" />
            {this.state.produtos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.produtos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {PRODUTOS_ITEMS_SUB.map((setting) => (
                <ListItemButton sx={{ pl: 8 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton sx={{ pl: 4 }} onClick={() => {
            this.setState({ vars: !this.state.vars })
          }}>
            <ListItemText className='btn-list-header' primary="Variáveis" />
            {this.state.vars ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.vars} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {VARS_ITEMS_SUB.map((setting) => (
                <ListItemButton sx={{ pl: 8 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>
      </Collapse>

    </>)

  }

  render() {

    return (<>

      <div className="ul-menu" style={{ color: "#3e6971" }}>

        {this.renderDashboard()}
        {this.renderEmpresas()}
        {this.renderDeclaracoes()}
        {this.renderXmlsPA()}
        {this.renderCalculos()}
        {this.renderLegislacao()}
        {this.renderAdmin()}
      </div>

    </>);

  }

}
